import request from '@/assets/js/http/request';
import getMemoryCache from '@/assets/js/utils/cache';

const BASE = process.env['API-GATEWAY'];
const memoryCache = getMemoryCache();

const Translations = {
  get: lang => request.get(`${BASE}/content/translations.json`, {
    locale: lang,
    app: 'Client Cabinet',
  }),
  content: url => memoryCache(url, () => request.get(`${BASE}/content/content`, { url })),
};

export default Translations;



// WEBPACK FOOTER //
// ./src/services/Translations.js